import { useState } from "react";
import { Modal, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { FormatTemplateSearch } from "@/formatTemplate/components/FormatTemplateSearch";

interface FormatTemplateSearchPopupProps {
  visible: boolean;
  onClose: () => void;
  onTemplateSelect: (template: any) => void;
  currentPrimaryTemplateId?: string;
}

export default function FormatTemplateSearchPopup({
  visible,
  onClose,
  onTemplateSelect,
}: FormatTemplateSearchPopupProps) {
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);

  const handleTemplateSelect = (template: any) => {
    setSelectedTemplate(template);
    onTemplateSelect(template);
    onClose(); // Auto-close after selection
  };

  const handleCancel = () => {
    setSelectedTemplate(null);
    onClose();
  };

  return (
    <Modal
      title={
        <div
          style={{
            backgroundColor: "#002945",
            color: "#ffffff",
            padding: "20px 24px 10px 24px",
            margin: "-20px -24px 0 -24px",
            borderRadius: "8px 8px 0 0",
          }}
        >
          Select Template for Chart
        </div>
      }
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
      ]}
      width={1200}
      style={{ top: 20 }}
      bodyStyle={{ padding: 0, maxHeight: "80vh", overflow: "hidden" }}
      closeIcon={<CloseOutlined style={{ color: "#ffffff" }} />}
    >
      <div style={{ height: "70vh", overflow: "auto" }}>
        <FormatTemplateSearch isSelectionTemplate={true} onTemplateSelect={handleTemplateSelect} />
      </div>
    </Modal>
  );
}
